import React from 'react';
import { Button, InputNumber, Select, Tabs } from 'antd';
import { ICONS } from '../../../utils/rescuePush';
import {
  DEFAULT_RESCUE_PUSH_SETTINGS,
  normalizeRescuePushSettings
} from '../../../utils/rescuePushSettings';
import { buildPhonePickPointTab } from './phonePickPointTab';
import { TokenManagementTable } from './TokenManagementTable';

function canSeeRescuePushSettings(shouldShowPage) {
  return !!(
    shouldShowPage?.('救援推送')
    || shouldShowPage?.('指挥系统设置')
    || shouldShowPage?.('系统设置')
    || shouldShowPage?.('前线队员设置')
  );
}

function canViewTokens(shouldShowPage) {
  return !!(
    shouldShowPage?.('令牌查看')
    || shouldShowPage?.('令牌管理')
  );
}

function canManageTokens(shouldShowPage) {
  return !!(shouldShowPage?.('令牌管理'));
}

/** 管理后台 · 指挥系统设置 · 救援推送 */
export function buildRescuePushSettingsTab(context) {
  const {
    shouldShowPage,
    handleSaveSystemSettings,
    updateSystemSettings,
    systemSettings
  } = context;

  if (!canSeeRescuePushSettings(shouldShowPage)) return null;

  const rescue = normalizeRescuePushSettings(systemSettings.rescuePushSettings);
  const patchRescue = (next) => updateSystemSettings((settings) => ({
    ...settings,
    rescuePushSettings: normalizeRescuePushSettings({
      ...(settings.rescuePushSettings || {}),
      ...next
    })
  }));

  const saveBar = (
    <div style={{ marginBottom: 16 }}>
      <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
    </div>
  );

  const targetTab = {
    key: 'target_push_settings',
    label: '目标推送',
    children: (
      <div>
        <h3>目标推送默认值</h3>
        {saveBar}
        <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
          打开「救援推送 → 目标推送」时使用以下默认图标和紧急程度，仍可在推送页临时改。
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 640 }}>
          <div>
            <h4>默认图标</h4>
            <Select
              style={{ width: '100%' }}
              value={rescue.defaultIcon}
              onChange={(defaultIcon) => patchRescue({ defaultIcon })}
              options={ICONS.map((item) => ({ value: item.value, label: item.label }))}
            />
          </div>
          <div>
            <h4>默认紧急程度</h4>
            <Select
              style={{ width: '100%' }}
              value={rescue.defaultLevel}
              onChange={(defaultLevel) => patchRescue({ defaultLevel })}
              options={[
                { value: '普通', label: '普通' },
                { value: '紧急', label: '紧急' }
              ]}
            />
          </div>
        </div>
      </div>
    )
  };

  // 手机选点设置（独立子标签）
  const phonePickPointTab = buildPhonePickPointTab(context);

  const tokenTab = {
    key: 'token_manage_settings',
    label: '令牌管理',
    children: (
      <div>
        <h3>App 绑定令牌默认设置</h3>
        {saveBar}
        <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
          设置 App 绑定令牌的默认有效期，用于前线队员绑定设备进行实时位置推送。
        </p>
        <div style={{ maxWidth: 320, marginBottom: 32 }}>
          <h4>默认有效期（天）</h4>
          <InputNumber
            min={0}
            max={365}
            value={rescue.trackerTtlDays}
            onChange={(value) => patchRescue({
              trackerTtlDays: value == null ? DEFAULT_RESCUE_PUSH_SETTINGS.trackerTtlDays : value
            })}
            style={{ width: '100%' }}
          />
          <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
            生成绑定令牌时的默认有效期；0 表示长期有效（默认 30 天）
          </p>
        </div>

        {canViewTokens(shouldShowPage) && (
          <div style={{ marginTop: 32 }}>
            <h3>已绑定令牌管理</h3>
            <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
              查看和管理已创建的 App 绑定令牌。
              {canManageTokens(shouldShowPage) 
                ? '您拥有「令牌管理」权限，可以编辑、撤销和删除令牌。' 
                : '您拥有「令牌查看」权限，只能查看令牌信息。'}
            </p>
            <TokenManagementTable canManage={canManageTokens(shouldShowPage)} />
          </div>
        )}
      </div>
    )
  };

  // 构建子标签数组
  const subTabs = [targetTab];
  if (phonePickPointTab) subTabs.push(phonePickPointTab);
  subTabs.push(tokenTab);

  return {
    key: 'rescue_push_settings',
    label: '救援推送',
    children: (
      <Tabs defaultActiveKey="target_push_settings" items={subTabs} />
    )
  };
}
